/* ImportAction.js */

"use strict";

const ImportScreenComponent = require("./ImportScreenComponent");
const ImportSummaryComponent = require("./ImportSummaryComponent");

class ImportAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        DeviceEntity,
        CustomFields,
        userSession,
        activityMonitor,
        steveIo,
        activeView,
        ExtendedPropType
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._deviceEntity = DeviceEntity;
        this._customFieldsEntity = CustomFields;
        this._modalUserFeedback = modalUserFeedback;
        this._steveIo = steveIo;
        this._activeView = activeView;
        this._activityMonitor = activityMonitor;
        this._extendedPropTypeEntityDef = ExtendedPropType;
        this.run = this.run.bind(this);
    }

    getOSMState() {
        return this._gameEditor.isOSMSolutionAvailable;
    }

    run() {
        let importScreenComponent = new ImportScreenComponent(
            this,
            this._logger,
            this._customFieldsEntity,
            this._userSession,
            this._steveIo,
            this._extendedPropTypeEntityDef
        );

        return this._modalUserFeedback
            .displayCustom(importScreenComponent, {dontHide: true})
            .then((result) => {
                this._activityMonitor.stopPolling();
                this._modalUserFeedback.displayLoading({
                    message: "Importing your file... This could take a moment",
                });
                const showProgFunc = (prog) => {
                    if (prog.msg !== "Starting Capture") {
                        this._modalUserFeedback.showLoadingProgress(
                            `${prog.successCount} of ${prog.targetCount}`
                        );
                    } else {
                        this._modalUserFeedback.hideDisplayed();
                    }
                };
                // result.needSnapshot : TODO. WorkInput in platformSdk
                // return this._deviceEntity.runImportDevicesWork(
                //     this._userSession.activeOrganization.id,
                //     result.importData,
                //     { launchAndForget: false },
                //     showProgFunc
                // );

                let workTarget = {};
                let workInput = {
                    devices: result.importData,
                    connectionInfoJtype: {},
                    oobConnectionJtype: {},
                    captureAfterImport: result.needSnapshot,
                };
                return this._deviceEntity.runImportWork(
                    this._userSession.activeOrganization.id,
                    workTarget,
                    workInput,
                    {launchAndForget: false},
                    showProgFunc
                );
            })
            .then((result) => {
                this._activityMonitor.startPolling();
                if (result.errorMsg) {
                    let err = new Error(result.errorMsg);
                    err.errorCode = "CaptureError";
                    err.errorMsg = result.errorMsg;
                    throw err;
                }

                return this._modalUserFeedback.displayCustom(
                    new ImportSummaryComponent(result, this._logger)
                );
            })
            .catch((err) => {
                this._activityMonitor.startPolling();
                if (err.userRejected) {
                    this._logger.warn({error: err}, "ImportAction.run() - User Canceled.");
                    return this._modalUserFeedback.hideDisplayed();
                } else {
                    this._logger.warn({error: err}, "ImportAction.run() - Error");
                    return this._modalUserFeedback.displayError(err).catch(() => {
                        return Promise.resolve();
                    });
                }
            });
    }
}

module.exports = ImportAction;

ImportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.entities.CustomFields",
    "$teve.userSession",
    "$teve.activityMonitor",
    "$teve.io",
    "gameEditor.activeView",
    "$teve.entities.ExtendedPropType",
];

ImportAction.$displayDetails = {
    type: "Action",
    name: "ImportAction",
    icon: "configdrift.import_devices",
    shown: true,
    title: "Import devices",
    order: 13,
};
